import { sortProfilesByLocation } from "../../utils/utils";
import {
  COMMODITIES_CLEAR_COMMODITIES,
  COMMODITIES_CLEAR_PROFILE_TO_EDIT,
  COMMODITIES_CLEAR_SINGLE_COMMODITY,
  COMMODITIES_FETCH_COMMODITIES,
  COMMODITIES_FETCH_COMMODITIES_CATALOG,
  COMMODITIES_FETCH_COMMODITY_GROUPS,
  COMMODITIES_FETCH_PROFILES,
  COMMODITIES_FETCH_SINGLE_COMMODITY,
  COMMODITIES_POST_PROFILE,
  COMMODITIES_SET_EDITED_PROFILE,
  COMMODITIES_SET_PROFILE_TO_EDIT,
  COMMODITY_CATEGORIES_FETCH,
  COMMODITY_SUBCATEGORIES_FETCH,
  COMMODITY_TRANSLATIONS
} from "../action-types/commodity-groups-types";

export const initialState = {
  commodityGroups: [],
  commodities: [],
  commoditiesCatalog: [],
  loading: false,
  rejected: false,
  commodity: {},
  profiles: [],
  profileToEdit: {},
  commodityTranslations: [],
  categories: [],
  subcategories: [],
};
export default function (state: any = initialState, action) {
  switch (action.type) {
    case COMMODITIES_FETCH_SINGLE_COMMODITY.REQUEST:
    case COMMODITIES_FETCH_COMMODITY_GROUPS.REQUEST:
    case COMMODITIES_FETCH_COMMODITIES.REQUEST:
    case COMMODITIES_FETCH_PROFILES.REQUEST:
    case COMMODITIES_FETCH_COMMODITIES_CATALOG.REQUEST:
    case COMMODITIES_POST_PROFILE.REQUEST:
    case COMMODITIES_SET_EDITED_PROFILE.REQUEST:
    case COMMODITY_CATEGORIES_FETCH.REQUEST:
    case COMMODITY_SUBCATEGORIES_FETCH.REQUEST:
      return {
        ...state,
        loading: true,
        rejected: false,
      };
    case COMMODITIES_FETCH_COMMODITY_GROUPS.SUCCESS:
      return {
        ...state,
        commodityGroups: [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case COMMODITY_CATEGORIES_FETCH.SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
        loading: false,
      };
    case COMMODITY_SUBCATEGORIES_FETCH.SUCCESS:
      return {
        ...state,
        subcategories: action.payload.data,
        loading: false,
      };
    case COMMODITY_CATEGORIES_FETCH.REJECTED:
      return {
        ...state,
        categories: [],
        loading: false,
      };
    case COMMODITY_SUBCATEGORIES_FETCH.REJECTED:
      return {
        ...state,
        subcategories: [],
        loading: false,
      };
    case COMMODITIES_FETCH_SINGLE_COMMODITY.REJECTED:
    case COMMODITIES_FETCH_COMMODITY_GROUPS.REJECTED:
    case COMMODITIES_FETCH_COMMODITIES.REJECTED:
    case COMMODITIES_FETCH_COMMODITIES_CATALOG.REJECTED:
    case COMMODITIES_FETCH_PROFILES.REJECTED:
    case COMMODITIES_POST_PROFILE.REJECTED:
    case COMMODITIES_SET_EDITED_PROFILE.REJECTED:
      return {
        ...state,
        loading: false,
        rejected: true,
      };
    case COMMODITIES_FETCH_COMMODITIES.SUCCESS:
      return {
        ...state,
        commodities: action.payload.id
          ? [...state.commodities, ...action.payload.data]
          : [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case COMMODITIES_FETCH_SINGLE_COMMODITY.SUCCESS:
      return {
        ...state,
        commodity: action.payload.data,
        loading: false,
        rejected: false,
      };
    case COMMODITIES_CLEAR_SINGLE_COMMODITY:
      return {
        ...state,
        commodity: {},
      };
    case COMMODITIES_CLEAR_COMMODITIES:
      return {
        ...state,
        commodities: [],
      };
    case COMMODITIES_FETCH_COMMODITIES_CATALOG.SUCCESS:
      return {
        ...state,
        commoditiesCatalog: [...action.payload.data],
      };
    case COMMODITIES_FETCH_PROFILES.SUCCESS:
      return {
        ...state,
        profiles: sortProfilesByLocation(action.payload.data),
      };
    case COMMODITIES_SET_PROFILE_TO_EDIT:
      return {
        ...state,
        profileToEdit: { ...action.payload },
      };
    case COMMODITIES_CLEAR_PROFILE_TO_EDIT:
      return {
        ...state,
        profileToEdit: {},
      };
    case COMMODITIES_POST_PROFILE.SUCCESS:
      return {
        ...state,
        profiles: [...state.profiles, action.payload],
      };
    case COMMODITIES_SET_EDITED_PROFILE.SUCCESS:
      return {
        ...state,
      };
    case COMMODITY_TRANSLATIONS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case COMMODITY_TRANSLATIONS.SUCCESS:
      return {
        ...state,
        commodityTranslations: action.payload.data.translations,
        loading: false,
      };
    case COMMODITY_TRANSLATIONS.REJECTED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return { ...state };
  }
}
